import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../utils/api';

export default function AdminRegistry() {
  const [projects, setProjects] = useState([]);
  const [batchDrafts, setBatchDrafts] = useState({});

  const load = async () => {
    try {
      const res = await api.get('/registry/projects');
      setProjects(res.data.projects || []);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to load registry admin');
    }
  };

  useEffect(() => { load(); }, []);

  const verify = async (id, decision) => {
    await api.post(`/registry/projects/${id}/verification`, { decision, notes: `Admin ${decision}` });
    toast.success(`Project ${decision}`);
    load();
  };

  const issueBatch = async (project) => {
    const draft = batchDrafts[project.id] || { quantity: project.estimated_annual_co2e || 100, verifier_name: 'CarbonX Admin Verifier' };
    const res = await api.post('/registry/issuance-batches', {
      project_id: project.id,
      quantity: Number(draft.quantity),
      verifier_name: draft.verifier_name,
      vintage: project.vintage,
    });
    toast.success('Issuance batch created');
    const batchId = res.data.batch.id;
    await api.post(`/tokenization/issuance-batches/${batchId}/mint`);
    toast.success('Batch minted to token class');
    load();
  };

  return (
    <div>
      <div className="section-tag">Admin</div>
      <h1 className="section-title">REGISTRY <span style={{ color: 'var(--neon-cyan)' }}>OPERATIONS</span></h1>
      <div className="card" style={{ marginTop: '1rem' }}>
        <table className="data-table">
          <thead><tr><th>Project</th><th>Status</th><th>Verification</th><th>Eligibility</th><th>Batch Qty</th><th>Actions</th></tr></thead>
          <tbody>
            {projects.map((project) => (
              <tr key={project.id}>
                <td>{project.project_name}</td>
                <td>{project.registry_status}</td>
                <td>{project.verification_status}</td>
                <td>{project.tokenization_eligibility}</td>
                <td>
                  <input
                    className="form-input"
                    style={{ minWidth: '120px' }}
                    type="number"
                    value={batchDrafts[project.id]?.quantity ?? project.estimated_annual_co2e ?? 100}
                    onChange={(e) => setBatchDrafts((prev) => ({ ...prev, [project.id]: { ...(prev[project.id] || {}), quantity: e.target.value, verifier_name: prev[project.id]?.verifier_name || 'CarbonX Admin Verifier' } }))}
                  />
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
                    <button className="btn btn-sm btn-primary" onClick={() => verify(project.id, 'approved')}>Approve</button>
                    <button className="btn btn-sm btn-danger" onClick={() => verify(project.id, 'rejected')}>Reject</button>
                    {project.verification_status === 'verified' && <button className="btn btn-sm btn-secondary" onClick={() => issueBatch(project)}>Issue + Mint</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
